/**
 * Helpers for mapping OpenAPI `format: date-time` strings to `Date`.
 *
 * The generated OpenAPI types use `string` for `date-time`, so we convert at the edge
 * of the app (API -> domain types).
 */

/**
 * Parses an ISO date-time string into a `Date`.
 *
 * - Returns `undefined` if the input is `undefined`/`null`.
 * - Throws if the date is invalid (helps catch backend/schema regressions early).
 */
export function parseDateTime(value: string): Date;
export function parseDateTime(value: string | undefined | null): Date | undefined;
export function parseDateTime(value: string | undefined | null): Date | undefined {
  if (value === undefined || value === null) return undefined;

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`Invalid date-time value: ${value}`);
  }
  return d;
}

/**
 * Parses a date-only string (e.g. "2024-03-10") into a `Date` at noon UTC.
 *
 * Using noon UTC avoids off-by-one day issues when displaying with
 * `toLocaleDateString()` in any timezone (the furthest offsets are UTC-12 and UTC+14,
 * both of which keep noon UTC on the same calendar day).
 */
export function parseDateOnly(value: string): Date {
  // Append T12:00:00Z so that the date stays on the correct calendar day
  // regardless of the user's local timezone.
  const d = new Date(`${value}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`Invalid date value: ${value}`);
  }
  return d;
}
